import { render, staticRenderFns } from "./TypeChecklistItemCategoryForm.vue?vue&type=template&id=a67b81e0&"
import script from "./TypeChecklistItemCategoryForm.vue?vue&type=script&lang=js&"
export * from "./TypeChecklistItemCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports